import React, { useEffect, useState } from "react";
import { ChangeTitle, decrypt, encrypt, formatPrice, toAbsoluteUrl } from "../../helpers/Reusable";
import { Link } from "react-router-dom";
import { apiHeader, postData } from "../../helpers/ApiHelper";
import { getCookie, setCookie } from "../../helpers/CookieComponent";
import MySubscription from "../mysubscription/MySubscription";

const MyOrder = () => {
  ChangeTitle("My Order");
  const [mainMenu, setMainMenu] = useState("professional");
  const [orderList, setOrderList] = useState([]);
  const [hasSubscription, setHasSubscription] = useState(false);

  console.log("orderList", orderList);

  // My Order List Api call
  const viewOrderList = async (type) => {
    const param = {
      limit: 0,
      offset: 0,
      type:type,
    };
    var response = await postData(
      "private/order/user/list",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      setOrderList(data);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Check if subscription data exists
  const checkSubscription = async () => {
    try {
      const userId = decrypt(getCookie("userId"));
      const param = {
        userId: userId,
        sort: "desc",
        sortBy: "created",
        limit: 1,
        offset: 0,
      };
      const practiseRes = await postData(
        "private/practiseplanpurchase/user/plan/list",
        param,
        apiHeader(false)
      );
      const readyRefRes = await postData(
        "readyreferenceplanpurchase/list",
        param,
        apiHeader(false)
      );

      const hasPractise =
        String(practiseRes?.status) === "200" &&
        String(practiseRes?.data?.status) === "200" &&
        practiseRes?.data?.data?.list?.length > 0;

      const hasReadyRef =
        String(readyRefRes?.status) === "200" &&
        String(readyRefRes?.data?.status) === "200" &&
        readyRefRes?.data?.data?.list?.length > 0;

      setHasSubscription(hasPractise || hasReadyRef);
    } catch (error) {
      console.error("Error checking subscription:", error);
    }
  };

  useEffect(() => {
    checkSubscription();
  }, []);

  useEffect(() => {
    if (mainMenu !== "subscription") {
      viewOrderList(mainMenu);
    }
  }, [mainMenu]);

  return (
    <>
      <div className="w-full p-[5%] min-h-screen bg-yellow">
        <div className="xxl:container mx-auto">
          <div className="w-full mb-[5%] md:mb-[2%]">
            <h1 className="hanson text-center mb-[1%] heading">My order</h1>
            <img
              className="mb-[2%] mx-auto"
              src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
              alt=""
            />
          </div>
          <div className="relative z-[2] mb-[5%] w-max flex justify-evenly p-[2%] md:p-[1%] mx-auto rr-main-menu webinar-menu">
            <button
              className={
                mainMenu == "professional"
                  ? "order-box-active order-box"
                  : "order-box"
              }
              onClick={() => setMainMenu("professional")}
            >
              Professional
            </button>
            <button
              className={
                mainMenu == "student"
                  ? "order-box-active order-box"
                  : "order-box"
              }
              onClick={() => setMainMenu("student")}
            >
              Students
            </button>
            {hasSubscription && (
              <button
                className={
                  mainMenu == "subscription"
                    ? "order-box-active order-box"
                    : "order-box"
                }
                onClick={() => setMainMenu("subscription")}
              >
                Plan
              </button>
            )}
          </div>
          {mainMenu === "subscription" ? (
            <MySubscription hideHeader />
          ) : (
            <div className="w-full lg:w-[80%] mx-auto orderlist-boxs">
              {orderList.length > 0 &&
                orderList.map((data) => (
                  <Link
                    to="/myorderdetail"
                    onClick={() => setCookie("myoid", data._id, {})}
                    className="flex flex-col sm:flex-row justify-between sm:items-center gap-10 p-[1rem] md:p-[1.5rem] mb-5 ol-box"
                  >
                    <div className="flex gap-5">
                      <div>
                        <div className="flex items-center gap-2">
                          <p className="olb-text-g">Order:</p>
                          <p className="olb-text-y">{data.orderCode}</p>
                        </div>
                        <div className="flex items-center gap-2">
                          <p className="olb-text-g">Order placed:</p>
                          <p className="olb-text-y">{data.createdDate}</p>
                        </div>
                        <p className="mb-4 olb-text-b-g">
                          {formatPrice(data.grandTotal, data.currency)} {data.currency}
                        </p>
                      </div>
                    </div>
                    <div className="text-end">
                      <Link
                        to="/myorderdetail"
                        onClick={() => setCookie("myoid", data._id, {})}
                      >
                        <button className="btn-view mx-4">View</button>
                      </Link>
                      <button
                        className={`${
                          data.status == "pending" ? "btn-pending" : "btn-cancel"
                        }`}
                      >
                        {data.status == "pending"
                          ? "Pending"
                          : data.status == "cancel"
                          ? "Cancel"
                          : ""}
                      </button>
                    </div>
                  </Link>
                ))}
              {orderList.length == 0 && (
                <h1 className="w-full text-center no-found">
                  Order not exist
                </h1>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default MyOrder;
